import { styled } from 'styled-components'
import { useState,useEffect } from 'react'
import AccountCircle from '@mui/icons-material/AccountCircle';
import BackDropLoginPrincipal from './backDropLoginPrincipal.jsx'
import { useSelector } from 'react-redux'
import InfoUserLogin from './infoUserLogin.jsx'
import Button from '@mui/material/Button';
import LoginIcon from '@mui/icons-material/Login';




const Container=styled.div`
	display:inline-flex;
	height:50px;
	justify-content:end;
	align-items:center;
	
`;

const ContainerUserImage=styled.div`
	position:relative;
	height:50px;
	display:flex;
	align-items:center
`;

const OnlineIcon=styled.div`
	position :absolute;
	height:12px;
	width:12px;
	top:10px;
	right:12px;
	border-radius:150px
`;
const ContainerInfoUserLoged=styled.div`
	position:absolute;
	top:60px;
	z-index:5;
	
`;
const ContainerBackdrop=styled.div`
	position:absolute;
 	z-index:1;
 	top:0px;
 	right:0px;
 	height:100%;

`;







export default function Login(props){

	let loginData=useSelector(state=>state.login);
	let [ userActive,setUserActive]=useState();
	let [ loginStatus, setLoginStatus ]=useState(false);
	let [ seeLogin,setSeeLogin ]=useState(false);
	let [ seeUserInfo,setSeeUserInfo ]=useState(false)


	

	useEffect(()=>{

			if(loginData.user&&loginData.login){
				setLoginStatus(true);
				setUserActive(loginData.user)}
			else{setLoginStatus(false);setUserActive("")};
			
	},[loginData]);

	let logeo=()=>{		
		loginStatus&&userActive?
		seeUserInfo?setSeeUserInfo(false):setSeeUserInfo(true)
		:setSeeLogin(true)
	};


	


	return(
		<Container >
			<ContainerUserImage>
				{userActive&&loginStatus?<AccountCircle onClick={logeo} style={{ fontSize: 35,margin:10 }} />
					:<Button variant="contained" onClick={logeo} startIcon={<LoginIcon />} >Iniciar sesion</Button>}
				{userActive&&loginStatus?<OnlineIcon  style={{backgroundColor:"green"}}/>:null}
			</ContainerUserImage>


			{userActive&&loginStatus?				
				<ContainerInfoUserLoged>
					{seeUserInfo?<InfoUserLogin open={seeUserInfo} close={setSeeUserInfo} userActive={userActive} />:null}
				</ContainerInfoUserLoged>:
				<ContainerBackdrop>
					<BackDropLoginPrincipal open={seeLogin} close={setSeeLogin}/>
				</ContainerBackdrop>}
		</Container>
		)
}